<table *ngIf="!(isMobile | async).matches">
  <tr>
    <th>Parcela</th>
    <th>Valor parcela</th>
    <th>Vencimento</th>
    <th>Status</th>
    <th></th>
  </tr>
  <tr *ngFor="let parcela of parcelas">
    <td>
      <div>
        <span *ngIf="parcela.nrParcela === 1">{{ acordoAvista ? 'À vista' : 'Entrada'}}</span>
        <span *ngIf="parcela.nrParcela > 1">Parcela {{parcela.nrParcela - 1}}/{{parcelas.length - 1}}</span>
      </div>
    </td>
    <td>
      <div>
        <span>{{parcela.valor | currency:'BRL' }}</span>
      </div>
    </td>
    <td>
      <div>
        {{parcela.dataVencParcela | date:'dd/MM/yyyy' }} 
      </div>
    </td>
    <td>
      <div>
        <span class="status" [ngClass]="getParcelaStatus(parcela).valor">
          {{getParcelaStatus(parcela).descricao}}
        </span>
      </div>
    </td>
    <td class="action-td">
      <div>
        <button 
          *ngIf="parcela?.statusPagamento?.valor !== StatusParcelaEnum.PAGO" 
          type="button" 
          mat-flat-button 
          color="primary" 
          (click)="handleEmitirBoleto(parcela)"    
          [disabled]="!parcela.linhaDigitavel">
          <span>
            {{ getParcelaStatus(parcela).valor === 'AGUARDANDO_PGMT' ? '2ª via do boleto' : 'Emitir boleto'}}
          </span>
        </button>
      </div>
    </td>
  </tr>
</table>

<ul *ngIf="(isMobile | async).matches" class="mobile-list">
  <li *ngFor="let parcela of parcelas">
    <span class="installment-index">
      <span *ngIf="parcela.nrParcela === 1">{{ acordoAvista ? 'À vista' : 'Entrada'}}</span>
      <span *ngIf="parcela.nrParcela > 1">Parcela {{parcela.nrParcela - 1}}/{{parcelas.length - 1}}</span>
    </span>

    <div class="action">
      <div class="due-date">
        <span class="date">{{parcela.dataVencParcela | date:'dd/MM/yyyy'}}</span>
        <span class="status" [ngClass]="getParcelaStatus(parcela).valor">
          {{getParcelaStatus(parcela).descricao}}
        </span>
      </div>
    </div>

    <strong class="value">{{parcela.valor | currencyMask }}</strong>

    <button 
      *ngIf="parcela.statusPagamento.valor !== StatusParcelaEnum.PAGO" 
      type="button" 
      mat-flat-button 
      color="primary" 
      (click)="handleEmitirBoleto(parcela)"      
      [disabled]="!parcela.linhaDigitavel">
      <span>
        {{ getParcelaStatus(parcela).valor === 'AGUARDANDO_PGMT' ? '2ª via do boleto' : 'Emitir boleto'}}
      </span>
    </button>
  </li>
</ul>